/*
 * Joy loyalty widget ("Clubul Herbaris"), "Recomandat pentru tine" carousel:
 * sale prices in red, as on the theme's own cards, and square photos.
 * The product cards sit in nested shadow roots that Joy's Custom CSS cannot
 * reach, so the rule is adopted into each card's shadow root here.
 */
(() => {
  if (!('adoptedStyleSheets' in Document.prototype)) return;

  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    :host([compare-at-price]) .joy-card-price-row joy-text { color: #dc3f32; }
    .joy-card-image-wrapper { aspect-ratio: 1 / 1; }
  `);

  const patchCards = (root) => {
    root.querySelectorAll('joy-product-card').forEach((card) => {
      const shadow = card.shadowRoot;
      if (shadow && !shadow.adoptedStyleSheets.includes(sheet)) {
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
      }
    });
  };

  const watchWidget = (widget) => {
    if (widget.dataset.hbJoy || !widget.shadowRoot) return;
    widget.dataset.hbJoy = '1';
    patchCards(widget.shadowRoot);
    new MutationObserver(() => patchCards(widget.shadowRoot)).observe(widget.shadowRoot, {
      childList: true,
      subtree: true,
    });
  };

  // The widget is created when the launcher is first clicked.
  const bodyObserver = new MutationObserver(() => {
    const widget = document.querySelector('joy-loyalty-widget');
    if (!widget || !widget.shadowRoot) return;
    watchWidget(widget);
    bodyObserver.disconnect();
  });

  const widget = document.querySelector('joy-loyalty-widget');
  if (widget && widget.shadowRoot) {
    watchWidget(widget);
  } else {
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
